<template>
  <div
    class="absolute inset-0 flex flex-col justify-center items-center z-50 bg-white/75 dark:bg-gray-900/75 transition-colors duration-300"
  >
    <!-- Spinner -->
    <div
      class="w-10 h-10 border-4 border-orange-500 border-t-transparent rounded-full animate-spin dark:border-yellow-400 dark:border-t-transparent"
    ></div>

    <!-- Text -->
    <p class="mt-3 text-gray-700 dark:text-gray-200 font-medium">{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: "Loading...",
    },
  },
  setup() {
    return {};
  },
};
</script>
